import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: calc(100% - 1.5rem);
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

const Title = styled.div`
  font-size: 0.875rem;
  color: #666666;
  margin-bottom: 0.75rem;
  font-weight: 400;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
`;

const Value = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${props => props.color || '#4b286d'};
  margin-bottom: 0.75rem;
  line-height: 1.2;
`;

const SubText = styled.div`
  font-size: 0.75rem;
  color: ${props => props.color || '#999999'};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: auto;
`;

const Badge = styled.span`
  background: ${props => props.background || '#f0f0f0'};
  color: ${props => props.color || '#666666'};
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
`;

const SummaryCard = ({ title, value, subText, badge, color, icon }) => {
  return (
    <Card>
      <Title>
        {icon && <span style={{ marginRight: '0.5rem' }}>{icon}</span>}
        {title}
      </Title>
      <Value color={color}>{value}</Value>
      {subText && <SubText>{subText}</SubText>}
      {badge && (
        <div style={{ marginTop: '0.5rem' }}>
          <Badge background={badge.background} color={badge.color}>
            {badge.text}
          </Badge>
        </div>
      )}
    </Card>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subText: PropTypes.string,
  badge: PropTypes.shape({
    text: PropTypes.string,
    background: PropTypes.string,
    color: PropTypes.string
  }),
  color: PropTypes.string,
  icon: PropTypes.node
};

SummaryCard.defaultProps = {
  subText: null,
  badge: null,
  color: '#4b286d',
  icon: null
};

export default SummaryCard;
